import { render } from "./BudgetCategory.vue?vue&type=template&id=e3ca7d3e&ts=true"
import script from "./BudgetCategory.vue?vue&type=script&lang=ts"
export * from "./BudgetCategory.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/mmwapp/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__